import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CircleFilledCheckIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M25 13C25 19.9036 19.4036 25.5 12.5 25.5C5.59644 25.5 0 19.9036 0 13C0 6.09644 5.59644 0.5 12.5 0.5C19.4036 0.5 25 6.09644 25 13ZM18.7974 8.26511C18.3397 7.80746 17.5977 7.80746 17.1401 8.26511C17.129 8.27616 17.1187 8.28787 17.109 8.30016L11.6834 15.2137L8.41231 11.9425C7.95466 11.4849 7.21267 11.4849 6.75502 11.9425C6.29738 12.4002 6.29738 13.1422 6.75502 13.5998L10.8901 17.7349C11.3477 18.1925 12.0897 18.1925 12.5474 17.7349C12.5576 17.7247 12.5672 17.714 12.5762 17.7027L18.814 9.90543C19.255 9.44659 19.2494 8.71714 18.7974 8.26511Z",
    fill: color
  }));
};
export default CircleFilledCheckIcon;